/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './item/extra-fields-list.item.component.ngfactory';
import * as i2 from '../../../../../app/shared/components/extra-fields-list/item/extra-fields-list.item.component';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/common';
import * as i5 from '../loader/loader.component.ngfactory';
import * as i6 from '../../../../../app/shared/components/loader/loader.component';
import * as i7 from '../../../../../app/shared/components/extra-fields-list/extra-fields-list.component';
import * as i8 from '../../../../../app/shared/services/http.service';
import * as i9 from '../../../../../app/shared/services/extra-field-validaton.service';
const styles_ExtraFieldsListComponent:any[] = ([] as any[]);
export const RenderType_ExtraFieldsListComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ExtraFieldsListComponent,data:{}});
function View_ExtraFieldsListComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'extra-fields-list-item',
      ([] as any[]),(null as any),[[(null as any),'extraFieldChanged']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('extraFieldChanged' === en)) {
          const pd_0:any = ((<any>_co.onExtraFieldChanged($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i1.View_ExtraFieldsListItemComponent_0,i1.RenderType_ExtraFieldsListItemComponent)),
      i0.ɵdid(1,49152,(null as any),0,i2.ExtraFieldsListItemComponent,([] as any[]),
          {extraField:[0,'extraField'],extraFieldsForm:[1,'extraFieldsForm'],validation:[2,
              'validation']},{extraFieldChanged:'extraFieldChanged'})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _v.context.$implicit;
    const currVal_1:any = _co.extraFieldsForm;
    const currVal_2:any = _co.validation;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_ExtraFieldsListComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),8,'form',[['novalidate',
      '']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
      (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,
      'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
      'submit'],[(null as any),'reset']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,2).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,2).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i3.ɵbf,([] as any[]),
      (null as any),(null as any)),i0.ɵdid(2,540672,[['f',4]],0,i3.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i0.ɵprd(2048,
      (null as any),i3.ControlContainer,(null as any),[i3.FormGroupDirective]),i0.ɵdid(4,
      16384,(null as any),0,i3.NgControlStatusGroup,[i3.ControlContainer],(null as any),
      (null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_ExtraFieldsListComponent_2)),
      i0.ɵdid(7,802816,(null as any),0,i4.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = _co.extraFieldsForm;
    _ck(_v,2,0,currVal_7);
    const currVal_8:any = _co.extraFields;
    _ck(_v,7,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,4).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,4).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,4).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,4).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,4).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,4).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,4).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_ExtraFieldsListComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'section',[['class',
      'extra_fields']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ExtraFieldsListComponent_1)),i0.ɵdid(3,
          16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵeld(5,0,(null as any),(null as any),1,'loader',([] as any[]),(null as any),
          (null as any),(null as any),i5.View_LoaderComponent_0,i5.RenderType_LoaderComponent)),
      i0.ɵdid(6,49152,(null as any),0,i6.LoaderComponent,([] as any[]),{loading:[0,
          'loading']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
          i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i7.ExtraFieldsListComponent = _v.component;
    const currVal_0:any = (_co.extraFields.length > 0);
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.loading;
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
export function View_ExtraFieldsListComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'extra-fields-list',
      ([] as any[]),(null as any),(null as any),(null as any),View_ExtraFieldsListComponent_0,
      RenderType_ExtraFieldsListComponent)),i0.ɵdid(1,4308992,(null as any),0,i7.ExtraFieldsListComponent,
      [i8.CommonHttpService,i3.FormBuilder,i9.ExtraFieldValidatonService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ExtraFieldsListComponentNgFactory:i0.ComponentFactory<i7.ExtraFieldsListComponent> = i0.ɵccf('extra-fields-list',
    i7.ExtraFieldsListComponent,View_ExtraFieldsListComponent_Host_0,{labelKey:'labelKey',
        formSubmitted:'formSubmitted'},{valid:'valid',filled:'filled'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/$$_gendir/app/shared/components/extra-fields-list/extra-fields-list.component.ngfactory.ts